<template>
  <div class="card_center">
    <h3>登录</h3>
    <!-- default-active-key="1" :animated="false" @change="tabChange"  -->
    <a-tabs
      v-model="tabKey"
      :tabBarStyle="{ borderBottom: 'unset', margin: '23px 0', fontSize: '18px', fontWeight: '500' }"
    >
      <a-tab-pane
        key="1"
        tab="密码登录"
        :forceRender="false"
      >
        <pwd-login
          ref="pwdLogin"
          :loading="loading"
          v-if="tabKey == 1"
          @login="login"
        ></pwd-login>
      </a-tab-pane>
      <a-tab-pane
        key="2"
        tab="验证码登录"
        :forceRender="false"
      >
        <verify-login
          ref="verifyLogin"
          :loading="loading"
          v-if="tabKey == 2"
          @login="login"
        ></verify-login>
      </a-tab-pane>
    </a-tabs>
    <div class="third-party-login">
      <p class="title">—— 第三方账号登录 ——</p>
      <WechatLogin />
      <div
        class="regist-instructions"
        v-if="$route.path === '/user/login'"
        @click="goState()"
      >关于乐私塾App学员端账号注册说明>></div>
    </div>
    <!-- <a-form :form="loginForm">
      <a-tabs default-active-key="1" :animated="false" :tabBarStyle="{ borderBottom: 'unset', margin: '23px 0' }">
        <a-tab-pane key="1" tab="密码登录" :forceRender="false">
          <a-form-item>
            <a-input
              placeholder="请输入手机号"
              v-decorator="[
                'account',
                {
                  rules: [{ required: true, pattern: /^1[34578]\d{9}$/, message: '手机号码格式不正确' }],
                  validateTrigger: 'blur'
                }
              ]"
            />
          </a-form-item>
          <a-form-item>
            <a-input-password
              placeholder="请输入密码"
              v-decorator="[
                'password',
                { rules: [{ required: true, message: '请输入正确密码' }], validateTrigger: 'blur' }
              ]"
            />
          </a-form-item>
        </a-tab-pane>
        <a-tab-pane key="2" tab="验证码登录" force-render :forceRender="false">
          <a-form-item>
            <a-input
              placeholder="请输入手机号"
              v-decorator="[
                'mobile',
                {
                  rules: [{ required: true, pattern: /^1[34578]\d{9}$/, message: '手机号码格式不正确' }],
                  validateTrigger: 'blur'
                }
              ]"
            />
          </a-form-item>
          <a-form-item>
            <div class="verify_box">
              <a-input
                placeholder="请输入验证码"
                :maxLength="6"
                v-decorator="[
                  'verifyCode',
                  { rules: [{ required: true, message: '请输入验证码' }], validateTrigger: 'blur' }
                ]"
              ></a-input>
              <button @click.stop.prevent="getCaptcha" class="verify_code">
                {{ state.send ? state.title : state.time + 's' }}
              </button>
            </div>
          </a-form-item>
        </a-tab-pane>
      </a-tabs>

      <a-form-item>
        <a-checkbox size="small" style="color: #AEB5C5;" :checked="checked" @change="change">
          <span>阅读并接受</span>
          <a style="color:#1564FF;">《乐私塾用户协议》</a>
        </a-checkbox>
      </a-form-item>
      <a-form-item>
        <a-button size="large" type="primary">登录</a-button>
      </a-form-item>
    </a-form>
    <div class="loginIsRegister">
      <span style="color: #AEB5C5;cursor: pointer;">忘记密码</span>
      <a-divider type="vertical" />
      <span style="color:#1564FF;cursor: pointer;" @click="resgoster">注册登录</span>
    </div>
    <p style="color: #AEB5C5;text-align: center;">关于乐私塾APP学员端账户注册说明>></p> -->
  </div>
</template>

<script>
import pwdLogin from './components/PawssordLogin.vue'
import verifyLogin from './components/VerifyCodeLogin.vue'
import WechatLogin from './components/WechatLogin.vue'
import { mapMutations, mapActions } from 'vuex'
import Vue from 'vue'
export default {
  components: {
    pwdLogin,
    verifyLogin,
    WechatLogin
  },
  data () {
    return {
      tabKey: '1',
      loading: false
    }
  },
  created () { },
  mounted () {
    console.log(this.$route.params === '/user/login')
    // console.log(this.$ls.get('code'))
  },
  methods: {
    ...mapMutations(['setUserInfo']),
    ...mapActions(['loginAsync']),
    async login (params) {
      try {
        this.loading = true
        const res = await this.loginAsync(params)
        res && this.$message.success('登录成功')
        this.$router.push({ name: 'study', replace: true, query: { ocode: Vue.ls.get('code') } })
      } catch (error) {
        if (this.tabKey === '1') {
          this.$refs.pwdLogin.setModal(true, error.message)
        } else {
          this.$refs.verifyLogin.setModal(true, error.message)
        }
      } finally {
        this.loading = false
      }
    },
    goState () {
      window.open(`./statement`)
    }
  }
}
</script>

<style lang="less" scoped>
@import './index.less';
.regist-instructions {
  position: absolute;
  transform: translate(-50%,100%);
  left: 50%;
  bottom: -20px;
  font-size: 12px;
  font-weight: 400;
  color: #9EA1A5;
  cursor: pointer;
}
.third-party-login {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 15px;
  .title {
    font-size: 14px;
    font-weight: 400;
    color: #9ea1a5;
  }
}
.card_center {
  width: 370px;
  margin: 0 auto;
  /deep/ .ant-tabs-ink-bar {
    height: 3px;
    border-radius: 1.5px;
  }
}
/deep/.ant-tabs-bar {
  margin: 0 0 24px !important;
}
/deep/.ant-tabs-tab {
  padding: 5px 0px;
  font-size: 18px;
}
// /deep/.ant-tabs-tab-active .ant-tabs-ink-bar {
//   color: #1564FF!important;
// }
// .main {
//   height: 100%;
//   min-height: 658px;
//   background-color: #f6f6ff;
//   overflow: hidden;
//   .main_content {
//     width: 1200px;
//     margin: 0 auto;
//     height: 100%;
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//   }
//   .main_back {
//     width: 573px;
//     height: 531px;
//     background-image: url(~@/assets/login_back.png);
//     background-size: cover;
//   }
//   .login_card {
//     width: 436px;
//     // height: 480px;
//     box-shadow: 0px 9px 28px 20px rgba(0, 0, 0, 0.04);
//     border-radius: 15px;
//     // .card_center {
//     // margin: 16px 22px 0 22px;
//     .card_title {
//       font-size: 34px;
//       line-height: 34px;
//       font-weight: bold;
//     }
//     .verify_box {
//       position: relative;
//       .verify_code {
//         position: absolute;
//         right: 0;
//         width: auto;
//         line-height: 45px;
//         padding: 0 18px;
//         cursor: pointer;
//         background: none;
//         border: none;
//         color: #1564FF;
//       }
//     }
//     .loginIsRegister {
//       padding-bottom: 34px;
//       margin-bottom: 12px;
//       border-bottom: 1px solid #d6dae3;
//     }
//     // }
//   }
// }
// /deep/ .ant-card-body {
//   padding: 38px 46px 16px;
// }
</style>
